export const UPGRADE_TITULO = 'Upgrade'

export const UPGRADE_DESCRICAO = 'Assine o plano anual e ganhe + de 10% de desconto e um presente exclusivo.'

export const CANCELAMENTO_TITULO = 'Solicitar cancelamento'

export const CANCELAMENTO_DESCRICAO = 'Precisa sair do clube por um tempo? Preencha nosso formulário de cancelamento e entraremos em contato com você.'

export const SEGUNDA_ASSINATURA_CURADORIA = 'Assinar a TAG Curadoria'

export const SEGUNDA_ASSINATURA_INEDITOS = 'Assinar a TAG Inéditos'

export const SEGUNDA_ASSINATURA_DESCRICAO = 'Assine a TAG Curadoria e TAG Inéditos e receba todo mês uma surpresa em dobro!'

export const DESCRICAO_CLUBE_INEDITOS = 'Assine e receba os best-sellers internacionais mais viciantes e ainda inéditos no Brasil, traduzidos em primeira mão para você.'

export const DESCRICAO_CLUBE_CURADORIA = 'Assine e receba os livros indicados aos associeados por grandes nomes da literatura.'

export const tiposDePlanos = {
  'FIDELIDADE': 'planosFidelidade',
  'NAO_PRESENTE': 'planosNaoPresente',
  'PRESENTE': 'planosPresente',
  'SEMESTRAL': 'planoSemestral'
}
